export enum CategoryCode {
  'Individual' = '1',
  'LocalCompany' = '2',
  'ForeignCompany' = '3',
  'UnregisteredLocalEntity' = '4',
  'LimitedLiabilityPartnerships' = '5',
  'UnregisteredForeignEntity' = '6',
}
